"use client";

import { forwardRef } from "react";

import { Typography } from "../typography";

import styles from "./divider.module.scss";
import { DividerProps } from "./divider.types";

const Divider = forwardRef<HTMLDivElement, DividerProps>(({ text }, ref) => {
  return (
    <div ref={ref} className={styles.divider}>
      <span className={styles.line} />
      <Typography variant="caption-1" className={styles.text}>
        {text}
      </Typography>
      <span className={styles.line} />
    </div>
  );
});

Divider.displayName = "Divider";

export { Divider };
